import DictApi from '@/api/dict';
import Field from '@/packages/field';
import {
  Component, Prop, Vue, Watch,
} from 'vue-property-decorator';

const style = require('./index.module.scss') as Dictionary;

@Component({ name: 'Registration' })
export default class Registration extends Vue {
  @Prop()
  private value!: number | undefined;

  // 户籍性质
  private registration: number | undefined | null = null;

  private created() {
    if (this.value) {
      this.registration = this.value;
    }
  }

  @Watch('value')
  private onValueChange(val: undefined | number) {
    if (val !== this.registration) {
      this.registration = val;
    }
  }

  public onValidator(): boolean {
    return typeof this.registration !== 'undefined';
  }

  private onChangeRegistration(val: number | undefined | null) {
    this.$emit('change', val);
  }

  private render() {
    return (
      <div class={style.Registration}>
        <Field
          v-model={this.registration}
          label="户籍性质"
          sub={true}
          onChange={() => this.onChangeRegistration(this.registration)}
          type="select"
          dictApi={DictApi.getRegistration}
          readonly={true}
        />
      </div>
    );
  }
}
